module.exports = __webpack_public_path__ + "media/assets/delete-4442fd36a2abd18e69aef90328408ae5.svg";